export const commandTheme = {
  baseStyle: {
    fontSize: 'xs',
    '[role=tooltip] > &': {
      ms: 1,
      _before: {
        content: '"•"',
        me: 1,
        fontSize: 'xs',
      },
    },
  },
}
